import { Outlet } from "react-router-dom";
import { FeatureFlagProvider } from "../services/featureFlagProvider";
import { DebugPanel } from "./debug-panel/DebugPanel";
/**
 * FeatureFlagRoute wraps routes with the FeatureFlagProvider
 * to ensure feature flags have access to route parameters
 */
export function FeatureFlagRoute() {
  return (
    <FeatureFlagProvider>
      <Outlet />
      <DebugPanel />
    </FeatureFlagProvider>
  );
}
